import { useZeroWorkspace } from "@/lib/zero"

// Undefined until Zero delivers the workspace, so a cold load does not redirect.
// Every workspace has the page; the recommendations engine behind it is gated
// separately by useIsAgentEngineAvailable.
export function useIsAgentPageAvailable(): boolean | undefined {
	const workspace = useZeroWorkspace()
	if (workspace === undefined) return undefined
	return true
}
